// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { _x } from '@wordpress/i18n';

// Import style for web component
import styles from './web-component-style.scss?inline';

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-menu-button-support' )
export class AutomatorBuilderItemMenuButtonSupport extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String, attribute: 'support-url' } ) accessor supportURL;

	// eslint-disable-next-line require-jsdoc
	render() {
		// Check if the URL exists at all
		if ( isEmpty( this.supportURL ) ) {
			return;
		}

		return html`
			<uo-button
				color="transparent"
				href=${ this.supportURL }
				target="_blank"
			>
				${ escapeHTML( _x( 'Support', 'Noun', 'uncanny-automator' ) ) }
			</uo-button>
		`;
	}
}
